module.exports = __webpack_public_path__ + "static/img/house-map.ee5cb94.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/house-map.jpg
// module id = 0rUD
// module chunks = 78